"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMicrophoneButtonStyle;

function createMicrophoneButtonStyle(_ref) {
  var microphoneButtonColorOnDictate = _ref.microphoneButtonColorOnDictate;
  return {
    '&.webchat__microphone-button': {
      '&.webchat__microphone-button--dictating .webchat__microphone-button__button': {
        '&, &:focus, &:hover': {
          '& .webchat__microphone-button__icon': {
            fill: microphoneButtonColorOnDictate
          }
        }
      }
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVNaWNyb3Bob25lQnV0dG9uU3R5bGUiLCJtaWNyb3Bob25lQnV0dG9uQ29sb3JPbkRpY3RhdGUiLCJmaWxsIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L01pY3JvcGhvbmVCdXR0b24udHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlTWljcm9waG9uZUJ1dHRvblN0eWxlKHsgbWljcm9waG9uZUJ1dHRvbkNvbG9yT25EaWN0YXRlIH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgICcmLndlYmNoYXRfX21pY3JvcGhvbmUtYnV0dG9uJzoge1xuICAgICAgJyYud2ViY2hhdF9fbWljcm9waG9uZS1idXR0b24tLWRpY3RhdGluZyAud2ViY2hhdF9fbWljcm9waG9uZS1idXR0b25fX2J1dHRvbic6IHtcbiAgICAgICAgJyYsICY6Zm9jdXMsICY6aG92ZXInOiB7XG4gICAgICAgICAgJyYgLndlYmNoYXRfX21pY3JvcGhvbmUtYnV0dG9uX19pY29uJzoge1xuICAgICAgICAgICAgZmlsbDogbWljcm9waG9uZUJ1dHRvbkNvbG9yT25EaWN0YXRlXG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0EsMkJBQVQsT0FBNkY7RUFBQSxJQUF0REMsOEJBQXNELFFBQXREQSw4QkFBc0Q7RUFDMUcsT0FBTztJQUNMLGdDQUFnQztNQUM5QiwrRUFBK0U7UUFDN0UsdUJBQXVCO1VBQ3JCLHVDQUF1QztZQUNyQ0MsSUFBSSxFQUFFRDtVQUQrQjtRQURsQjtNQURzRDtJQURqRDtFQUQzQixDQUFQO0FBV0QifQ==